import React, { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { LandingScreen } from './components/LandingScreen';
import { QuizScreen } from './components/QuizScreen';
import { NameScreen } from './components/NameScreen';
import { ResultScreen } from './components/ResultScreen';
import { OfferScreen } from './components/OfferScreen';
import { questions } from './data/questions';
import { initPixel, trackPageView, trackEvent } from './utils/pixel';
type Step = 'landing' | 'quiz' | 'name' | 'result' | 'offer';
export function App() {
  const [step, setStep] = useState<Step>('landing');
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [answers, setAnswers] = useState<string[]>([]);
  const [userName, setUserName] = useState('');
  // Initialize Meta Pixel once on mount
  useEffect(() => {
    initPixel();
    trackEvent('ViewContent', {
      content_name: 'Landing',
      content_category: 'Funnel Step'
    });
  }, []);
  // Track every funnel step change as a PageView + ViewContent
  useEffect(() => {
    trackPageView();
    trackEvent('ViewContent', {
      content_name: `Step: ${step}`,
      content_category: 'Funnel Step'
    });
  }, [step]);
  // Track quiz progress on every question change
  useEffect(() => {
    if (step !== 'quiz') return;
    trackEvent('QuizProgress', {
      question_number: currentQuestionIndex + 1,
      total_questions: questions.length,
      progress_percent: Math.round((currentQuestionIndex + 1) / questions.length * 100)
    });
  }, [step, currentQuestionIndex]);
  const handleStart = () => {
    trackEvent('Lead', {
      content_name: 'Quiz Started'
    });
    setStep('quiz');
    window.scrollTo(0, 0);
  };
  const handleAnswer = (answer: string) => {
    const newAnswers = [...answers, answer];
    setAnswers(newAnswers);
    trackEvent('QuizAnswered', {
      question_number: currentQuestionIndex + 1,
      answer_text: answer
    });
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(prev => prev + 1);
      window.scrollTo(0, 0);
    } else {
      trackEvent('QuizCompleted', {
        total_answers: newAnswers.length
      });
      setStep('name');
      window.scrollTo(0, 0);
    }
  };
  const handleNameSubmit = (name: string) => {
    setUserName(name);
    trackEvent('CompleteRegistration', {
      content_name: 'Name Submitted'
    });
    setStep('result');
    window.scrollTo(0, 0);
  };
  const handleResultContinue = () => {
    trackEvent('ViewedResult', {
      content_name: 'Continued to Offer'
    });
    setStep('offer');
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-cream selection:bg-mint-green selection:text-forest-green" data-id="element-0">
      <AnimatePresence mode="wait" data-id="element-1">
        {step === 'landing' && <LandingScreen key="landing" onStart={handleStart} data-id="element-2" />}

        {step === 'quiz' && <QuizScreen key="quiz" currentQuestionIndex={currentQuestionIndex} onAnswer={handleAnswer} data-id="element-3" />}

        {step === 'name' && <NameScreen key="name" onSubmit={handleNameSubmit} data-id="element-4" />}

        {step === 'result' && <ResultScreen key="result" userName={userName} answers={answers} onContinue={handleResultContinue} data-id="element-5" />}

        {step === 'offer' && <OfferScreen key="offer" userName={userName} data-id="element-6" />}
      </AnimatePresence>
    </div>;
}